import React, { useState, useEffect } from 'react';
import { auth } from 'utils/firebase';

export default function Admin() {
  const [targetEmail, setTargetEmail] = useState('');
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [currentTarget, setCurrentTarget] = useState('');
  const [adminToken, setAdminToken] = useState('');
  const [originalEmail, setOriginalEmail] = useState('');

  useEffect(() => {
    const getAdminInfo = async () => {
      if (auth.currentUser) {
        try {
          const token = await auth.currentUser.getIdToken();
          setAdminToken(token);
          setOriginalEmail(auth.currentUser.email);
        } catch (error) {
          console.error('Error getting admin token:', error);
        }
      }
    };

    getAdminInfo();
  }, []);

  const startImpersonation = async () => {
    if (!targetEmail.trim()) {
      alert('Please enter a target email');
      return;
    }

    try {
      // Get a fresh admin token
      const freshAdminToken = await auth.currentUser.getIdToken(true); // Force refresh
      
      const headers = window.globalHeaders || {};
      headers['x-api-key'] = freshAdminToken;
      headers['x-api-email'] = targetEmail;
      window.globalHeaders = headers;

      setIsImpersonating(true);
      setCurrentTarget(targetEmail);
      setAdminToken(freshAdminToken); // Update stored token
      
      console.log(`🎭 Started impersonating: ${targetEmail}`);
      console.log('Fresh admin token:', freshAdminToken.substring(0, 20) + '...');
    } catch (error) {
      console.error('Error getting fresh admin token:', error);
      alert('Failed to get admin token');
    }
  };

  const stopImpersonation = () => {
    if (window.globalHeaders) {
      window.globalHeaders['x-api-email'] = originalEmail;
    }

    setIsImpersonating(false);
    setCurrentTarget('');
    
    console.log('🎭 Stopped impersonating, restored to:', originalEmail);
  };

  return (
    <div>
      <h1>Admin Dashboard</h1>
      
      <input
        type="email"
        value={targetEmail}
        onChange={(e) => setTargetEmail(e.target.value)}
        placeholder="user@example.com"
      />
      
      {!isImpersonating ? (
        <button onClick={startImpersonation}>Start Impersonation</button>
      ) : (
        <button onClick={stopImpersonation}>Stop Impersonation</button>
      )}
      
      {isImpersonating && <p>Impersonating: {currentTarget}</p>}
    </div>
  );
}